import { render, staticRenderFns } from "./UpdateContact.vue?vue&type=template&id=0bc66d35&scoped=true"
import script from "./UpdateContact.vue?vue&type=script&lang=js"
export * from "./UpdateContact.vue?vue&type=script&lang=js"
import style0 from "./UpdateContact.vue?vue&type=style&index=0&id=0bc66d35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc66d35",
  null
  
)

export default component.exports